import { useActuarialNotesMutation, useActuarialNotesToCFEMutation } from "../../../api/actuarial/actuarial-api"
import { useUploadFileDocumentsMutation } from "../../../api/files/files-api";
import { useCreateCategoryMutation, useUpdateCategoryMutation } from "../../../api/it/account-category/account-category-api";
export const useMutation = () => {
    
    // const [computeRates, { isLoading: isLoadingComputeRates }] = useComputeRatesMutation()
    
    // const [downloadRatesTemplate, { isLoading: isLoadingDownloadRatesTemplate }] = useDownloadRatesTemplateMutation();
    // const [uploadRatesExcel, { isLoading: isLoadingUploadRatesExcel }] = useUploadRatesExcelMutation();
    // const [downloadMasterAttachedFile, { isLoading: isLoadingDownloadMasterAttachedFile }] = useDownloadMasterFileCSVFileMutation();
    // const [downloadSupportingDocuments, { isLoading: isLoadingDownloadSupportingDocuments }] = useDownloadSupportingDocumentsMutation();
    // const [downloadActDocuments, { isLoading: isLoadingDownloadActDocuments }] = useDownloadFileDocumentsMutation();
    
    // const [releaseProposal, { isLoading: isLoadingReleaseProposal}] = useReleaseProposalMutation();
    // const [computeTotalAmountPremium, { isLoading: isLoadingComputeTotalAmountPremium }] = useComputeTotalAmountPremiumMutation();
    // const [evidenceNotes, { isLoading: isLoadingEvidenceNotes }] = useComputeEvidenceNotesMutation();
    // const [createProposal, { isLoading: isLoadingCreateProposal }] = useCreateProposalMutation();
    // const [uploadMasterCSVFile, { isLoading: isLoadingUploadMasterCSVFile }] = useUploadMasterCSVFileMutation();
    // const [updateProposal, { isLoading: isLoadingUpdateProposal }] = useUpdateProposalMutation();
    // const [createProposalAsDraft, { isLoading: isLoadingCreateProposalAsDraft } ] = useCreateProposalAsDraftMutation();
    // const [saveSupportingDocuments, { isLoading: isLoadingSaveSupportingDocuments}]= useUploadSupportingDocumentsMutation()

    // const [resetPasswordUser, { isLoading: isLoadingResetPasswordUser }] = useResetPasswordUserMutation();
    // const [deactivateUser, { isLoading: isLoadingDeactivateUser }] = useDeactivateUserMutation();

    // const [addCommentChat, { isLoading: isLoadingAddCommentChat, isError: isErrorAddCommentChat }] = useAddCommentProposalMutation()
    // const [deleteComment, { isLoading: isLoadingDeleteComment, isError: isErrorDeleteComment }] = useDeleteCommentProposalMutation()
    // const [updateComment, { isLoading: isLoadingUpdateComment, isError: isErrorUpdateComment }] = useUpdateCommentProposalMutation()

    // const [approveExtension, { isLoading: isLoadingApproveExtension }] = useApprovedProposalExtensionMutation()
    // const [declinedExtension, { isLoading: isLoadingDeclinedExtension }] = useDeclinedProposalExtensionMutation()
    // const [requestProposalExtension, { isLoading: isLoadingRequestProposalExtension }] = useRequestProposalExtensionMutation()

    // const [createAccount, { isLoading: isLoadingCreateAccount }] = useCreateNewUserMutation();
    // const [updateUserAccountInfo, { isLoading: isLoadingUpdateUserAccountInfo, isError: isErrorUpdateUserAccountInfo }] = useUpdateUserAccountInfoMutation();
    // const [updateProfile, { isLoading: isLoadingUpdateProfile }] = useUpdateProfileMutation();
    
    
    const [createCategory, { isLoading: isLoadingCreateCategory }] = useCreateCategoryMutation();
    const [updateCategory, { isLoading: isLoadingUpdateCategory }] = useUpdateCategoryMutation();

    const [uploadDocuments, { isLoading: isLoadingUploadDocuments}] = useUploadFileDocumentsMutation()
    const [saveNotes, { isLoading: isLoadingSaveNotes }] = useActuarialNotesMutation()
    const [saveNotesToCFE, { isLoading: isLoadingSaveNotesToCFE }] = useActuarialNotesToCFEMutation()

    // const [requestAmendment, { isLoading: isLoadingRequestAmendment }] = useCreateRequestAmendmentMutation()
    // const [declineRequestAmendment, { isLoading: isLoadingDeclineRequestAmendment }] = useDeclineRequestAmendmentMutation()
    // const [acceptRequestAmendment, { isLoading: isLoadingAcceptRequestAmendment }] = useAcceptRequestAmendmentMutation()


    return {
        // computeRates,
        // isLoadingComputeRates,

        // downloadRatesTemplate,
        // isLoadingDownloadRatesTemplate,

        // uploadRatesExcel,
        // isLoadingUploadRatesExcel,

        // downloadMasterAttachedFile,
        // isLoadingDownloadMasterAttachedFile,

        // releaseProposal,
        // isLoadingReleaseProposal,

        // computeTotalAmountPremium,
        // isLoadingComputeTotalAmountPremium,

        // evidenceNotes,
        // isLoadingEvidenceNotes,
        
        // createProposal,
        // isLoadingCreateProposal,

        // uploadMasterCSVFile,
        // isLoadingUploadMasterCSVFile,

        // updateProposal,
        // isLoadingUpdateProposal,

        // createProposalAsDraft,
        // isLoadingCreateProposalAsDraft,

        // resetPasswordUser,
        // isLoadingResetPasswordUser,

        // deactivateUser,
        // isLoadingDeactivateUser,

        // addCommentChat,
        // isErrorAddCommentChat,
        // isLoadingAddCommentChat,

        // deleteComment,
        // isErrorDeleteComment,
        // isLoadingDeleteComment,

        // updateComment,
        // isErrorUpdateComment,
        // isLoadingUpdateComment,

        // approveExtension,
        // isLoadingApproveExtension,

        // declinedExtension,
        // isLoadingDeclinedExtension,

        // requestProposalExtension,
        // isLoadingRequestProposalExtension,

        // createAccount,
        // isLoadingCreateAccount,

        // updateUserAccountInfo,
        // isLoadingUpdateUserAccountInfo,
        // isErrorUpdateUserAccountInfo,

        createCategory,
        isLoadingCreateCategory,

        updateCategory,
        isLoadingUpdateCategory,

        // updateProfile,
        // isLoadingUpdateProfile,

        // saveSupportingDocuments,
        // isLoadingSaveSupportingDocuments,

        // downloadSupportingDocuments,
        // isLoadingDownloadSupportingDocuments,

        // downloadActDocuments,
        // isLoadingDownloadActDocuments,

        uploadDocuments,
        isLoadingUploadDocuments,

        saveNotes,
        isLoadingSaveNotes,

        saveNotesToCFE,
        isLoadingSaveNotesToCFE,

        // requestAmendment,
        // isLoadingRequestAmendment,

        // declineRequestAmendment,
        // isLoadingDeclineRequestAmendment,

        // acceptRequestAmendment,
        // isLoadingAcceptRequestAmendment,
    }
}